import React from 'react';
import { tokens as defaultTokens } from '../tokens';
import Wordmark from './Wordmark';

export default function TopBar({ tokens = defaultTokens, right = null, title = null, amberTitle = false, background = null, border = true }) {
  return (
    <div style={{
      position: 'sticky', top: 0, zIndex: 15,
      padding: '14px 22px 12px',
      background: background || `linear-gradient(to bottom, ${tokens.ground} 85%, transparent)`,
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      borderBottom: border ? `1px solid ${tokens.edge}` : 'none',
    }}>
      {title ? (
        <span style={{
          fontFamily: tokens.fontMono,
          fontSize: 11,
          letterSpacing: '0.22em',
          textTransform: 'uppercase',
          color: amberTitle ? tokens.accent : tokens.textMid,
        }}>{title}</span>
      ) : <Wordmark tokens={tokens} size={11} />}
      {right}
    </div>
  );
}
